import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormTextField } from '@/components/Form/FormTextField/FormTextField';
import { useDcrFields } from '@/features/DataChangeRequest/_constants/useDcrFields';
import type { NameSectionValuesIn } from '@/features/DataChangeRequest/_schemas/HcoSchemas/NameSection.validation';
import { DcrFormController } from '@/features/DataChangeRequest/DcrFormController/DcrFormController';
import { FormSection } from '@/features/DataChangeRequest/DcrModal/FormSection/FormSection';

export const HcoNameSection = () => {
	const { t } = useTranslation();
	const { hcoFields } = useDcrFields();
	const {
		control,
		formState: { dirtyFields }
	} = useFormContext<NameSectionValuesIn>();
	const section = 'name';

	return (
		<FormSection title={t('Name')} id={section}>
			<DcrFormController
				name='hcoNameCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='hcoNameCda_V'
						name={field.name}
						label={hcoFields.hcoNameCda_V.label}
						isRequired
						isDirty={!!dirtyFields.hcoNameCda_V}
						indicateError={fieldState.error ? true : false}
						defaultValue={(field.value ?? '') as string}
						onChange={field.onChange}
					/>
				)}
			/>
		</FormSection>
	);
};
